import InnerImageZoom from './InnerImageZoom';
export default InnerImageZoom;
